/**
 * Spanish histogram prompts and data titles (ADR 0099 §2). Same shape and
 * the same numbers as the English file. Every noun is masculine, so one
 * "cuántos" fits them all.
 */
export const histogramPrompts = {
    oneInterval: (noun: string, low: number, high: number, unit: string) =>
        `¿Cuántos ${noun} hay de ${low} a ${high}${unit}?`,
    atLeast: (noun: string, low: number, unit: string) => `¿Cuántos ${noun} hay con ${low}${unit} o más?`,
    total: (noun: string) => `¿Cuántos ${noun} hay en total?`,
    most: (noun: string) => `¿Qué intervalo tiene más ${noun}?`,
};

export const histogramContexts: {
    title: string;
    noun: string;
    unit: string;
    width: number;
    starts: number[];
    limit: number;
}[] = [
    { title: 'Puntajes en un examen de matemáticas', noun: 'puntajes', unit: '', width: 10, starts: [40, 50], limit: 100 },
    { title: 'Estatura de los estudiantes de una clase (cm)', noun: 'estudiantes', unit: ' cm de estatura', width: 5, starts: [120, 125, 130], limit: 169 },
    { title: 'Tiempo en dar una vuelta a la pista (segundos)', noun: 'tiempos', unit: ' segundos', width: 5, starts: [50, 55, 60, 65], limit: 100 },
    { title: 'Edades de las personas en una fiesta', noun: 'invitados', unit: ' años', width: 5, starts: [5, 10], limit: 49 },
    { title: 'Puntos anotados en cada partido de baloncesto', noun: 'partidos', unit: ' puntos', width: 10, starts: [40, 50, 60], limit: 109 },
    { title: 'Distancia de cada salto de longitud (cm)', noun: 'saltos', unit: ' cm', width: 10, starts: [100, 110, 120], limit: 199 },
];
